export const LOCAL_STORAGE_PROVIDER_KEY = 'recent_login_type';
export const LOCAL_STORAGE_SCHEDULE_SNACKBAR_KEY =
  'last_display_schedule_snackbar';
export const LOCAL_STORAGE_SNS_DISPLAY_KEY = 'last_display_sns_bnr';
export const LOCAL_STORAGE_ACCOUNT_FORM_KEY = 'local_storage_account_form_key';
